/**
 * @generated SignedSource<<306f191d0cd73651636e7b07da55f019>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ContentModeFragmentProvider_content$data = {
  readonly contentProperties: {
    readonly draft: {
      readonly contentMode: string | null;
    } | null;
    readonly latest: {
      readonly contentMode: string | null;
    } | null;
  } | null;
  readonly id: string | null;
  readonly " $fragmentType": "ContentModeFragmentProvider_content";
};
export type ContentModeFragmentProvider_content$key = {
  readonly " $data"?: ContentModeFragmentProvider_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentModeFragmentProvider_content">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "contentMode"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ContentModeFragmentProvider_content",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "ContentProperties",
      "kind": "LinkedField",
      "name": "contentProperties",
      "plural": false,
      "selections": [
        {
          "concreteType": "PublishedContentProperties",
          "kind": "LinkedField",
          "name": "latest",
          "plural": false,
          "selections": (v0/*: any*/)
        },
        {
          "concreteType": "DraftContentProperties",
          "kind": "LinkedField",
          "name": "draft",
          "plural": false,
          "selections": (v0/*: any*/)
        }
      ]
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "2d0903d9b16c25939114ba4a37ade7bd";

export default node;
